import { createIcon } from '@chakra-ui/icons';

export const CloudCheck = createIcon({
  displayName: 'CloudCheck',
  viewBox: '0 0 17 14',
  path: [
    <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6553 13.8068C14.6267 13.8068 16.2247 12.2087 16.2247 10.2374C16.2247 8.26604 14.6267 6.66797 12.6553 6.66797C10.684 6.66797 9.08594 8.26604 9.08594 10.2374C9.08594 12.2087 10.684 13.8068 12.6553 13.8068Z"
        fill="currentColor"
      />
      <path
        d="M11.2305 10.6051L12.1607 11.5353L14.0817 9.30859"
        stroke="white"
        strokeWidth="1.20924"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M6.80204 12.0905H3.77895C2.11625 12.0905 0.755859 10.7301 0.755859 9.0674C0.755859 7.63143 1.73836 6.4222 3.02318 6.11989C3.17433 3.17238 5.66838 0.753906 8.69147 0.753906C11.1746 0.753906 13.2498 2.33464 14.0376 4.53277"
        stroke="currentColor"
        strokeWidth="1.51154"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
